import {allStores} from '@/store/store';
import {AxiosResponse} from 'axios';

export const clearAllHttpErrors = (location?: string) => {
  if (location) {
    console.log('Clearing all errors from ', location);
  }
  allStores.forEach((s) => s.clearErrors());
};

export interface IPxError {
  name: string,
  message: string
  data?: any
  viewed?: boolean
  status?: number,
  statusText?: string,
}

export const processReason = (reason: { response?: AxiosResponse, name?: string, message?: string }) => {
  const errors: IPxError[] = [];


  if (reason.response) { // Server sent a response
    const {status} = reason.response;
    const {statusText} = reason.response;
    const {data} = reason.response;
    // console.debug(status, data, statusText, reason.response);
    if (status === 400) {
      errors.push({
        name: 'Bad Request',
        message: data,
        status,
        statusText,
        viewed: false,
      });
    } else if (status === 404) {
      const {url} = reason.response.config;
      Object.keys(data).forEach((key) => {
        errors.push({
          name: status.toString(),
          message: url || '',
          status,
          statusText,
          viewed: false,
          data: {url},
        });
      });
    } else {
      errors.push({
        name: reason.response.status.toString(),
        message: reason.response.statusText,
        data: reason.response,
        viewed: false,
      });
    }
  } else { // No response from server
    errors.push({
      name: (reason.name || 'Unknown Error').toString(),
      message: (reason.message || 'An error occurred'),
      data: reason,
      viewed: false,
    });
  }


  return errors;
};
